import { Link } from "react-router-dom";

export default function PortalBack({ to = "/list/dashboard", label = "Back" }) {
  return <Link to={to} data-testid="portal-back" className="eyebrow !text-[0.6rem] text-ivory/60 hover:text-gold transition-colors">← {label}</Link>;
}
